export function initScrollAnimations(options = {}) {
    const {
        selector = ".animated",
        hiddenClass = "not-in-view",
        threshold = 0,
        rootMargin = "0px 0px 15% 0px",
    } = options;

    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
        elements.forEach((el) => el.classList.remove(hiddenClass));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                entry.target.classList.remove(hiddenClass);
                observer.unobserve(entry.target);
            });
        },
        { threshold, rootMargin }
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
        observer.disconnect();
    };
}